import styled from 'styled-components';

export const FooterRow = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
  flex-wrap: wrap;
  align-items: center;
`;

export const FooterCol = styled.div`
  padding: 10px;
  min-width: 150px;
  margin-left: 30pxs;
`;

export const LogoFooterCol = styled(FooterCol)`
  width: 50px;
  img {
    width: 100%;
    height: auto;
  }
`;
